import React, { Component } from 'react';
import { connect } from "react-redux";
import './overlayModal.css';

import { closeModal } from '../../../redux/actions';

class OverlayModal extends Component {
  render() {
    return (
      <div className={`overlayModal ${this.props.active}`}>
        <div className='overlay' onClick={() => this.props.closeModal(this.props.screen)} />
        <div className='card'>
          <p className='mdi mdi-close clickable' onClick={() => this.props.closeModal(this.props.screen)} />
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default connect(null, { closeModal })(OverlayModal);
